const MASTER_KEY = "f4c7cbbb-c4f3-48bf-90e2-a7521815d25d";

class GetSchemaUseCase {
  async execute(collection) {
    const session = localStorage.getItem("SESSION");

    const headers = {
      "Content-Type": "application/json",
      "X-Application-Id": "forbes-negrec",
      // "X-Master-Key": MASTER_KEY,
    };

    if (session) {
      headers["X-Session-Token"] = session;
    }

    const res = await fetch(`https://api.innque.com/v1/schemas/${collection}`, {
      headers,
    });

    if (!res.ok) {
      const body = await res.json();
      const err = new Error(body.error || `HTTP ${res.status}`);
      err.code = res.status;
      throw err;
    }

    return res.json();
  }
}

export default GetSchemaUseCase;
